
const getters = {
	jieci: state => state.app.jieci,
	lunci: state => state.app.lunci,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  branchName: state => state.user.branchName,
  branchInnerCode: state => state.user.branchInnerCode,
  branchType: state => state.user.branchType,
  branchParentInnerCode: state => state.user.branchParentInnerCode,
  branchParentName: state => state.user.branchParentName,
  roles: state => state.user.roles,
  tourTableList: state => state.pzlzClassperson.tourTableList,
  inspectionEntityStatus: state => state.fourList.inspectionEntityStatus,
  status:state => state.pzlzClassperson.status,
  feedbackTime:state => state.pzlzClassperson.feedbackTime,
  inspectedUnitCode:state => state.pzlzClassperson.inspectedUnitCode,
  inspectedUnitName:state => state.pzlzClassperson.inspectedUnitName,
  inspectionEntityid:state => state.pzlzClassperson.inspectionEntityid,
  inspectionStartTime:state => state.pzlzClassperson.inspectionStartTime,
  inspectionEndTime:state => state.pzlzClassperson.inspectionEndTime,
  treeOid:state => state.pzlzClassperson.treeOid,
  treeOidMaterial:state => state.offlineMaterial.treeRowOid,
  batchList:state => state.fourList.batchList,
  routerRow:state => state.pzlzClassperson.routerRow,
  rowStatus:state => state.pzlzClassperson.rowStatus,
  upAuditIdOpen:state => state.pzlzClassperson.upAuditIdOpen,
  isAuditOpen:state => state.pzlzClassperson.isAuditOpen,
  inspectionEntity:state => state.pzlzClassperson.inspectionEntity,
  societyOpen:state => state.pzlzClassperson.societyOpen,
  partyOpen:state => state.pzlzClassperson.partyOpen,
  wpsFile: state => state.pzlzClassperson.wpsFile,
  questionLabelOption: state => state.pzlzClassperson.questionLabelOption,
  inspectedStatus: state => state.pzlzClassperson.inspectedStatus,
  optionsList: state => state.app.optionsList,
  PaiList: state => state.app.PaiList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js